import clsx from "clsx";
import { TrendingDown, TrendingUp } from "lucide-react";

type TabValue = "expense" | "income";

interface CategoryTypeTabsProps {
  value: TabValue;
  onChange: (value: TabValue) => void;
  expenseCount: number;
  incomeCount: number;
  isHe: boolean;
}

export function CategoryTypeTabs({
  value,
  onChange,
  expenseCount,
  incomeCount,
  isHe,
}: CategoryTypeTabsProps) {
  return (
    <div
      role="tablist"
      aria-label={isHe ? "סוג קטגוריה" : "Category type"}
      className="inline-flex items-center gap-[2px] rounded-[10px] border border-[var(--border-color)] bg-[var(--bg-secondary)] p-[3px]"
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === "expense"}
        onClick={() => onChange("expense")}
        className={clsx(
          "inline-flex items-center rounded-[7px] px-[14px] py-[6px] text-[12px] font-medium transition-all duration-150 [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
          value === "expense"
            ? "bg-[var(--bg-hover)] text-[var(--text-primary)] shadow-[0_1px_2px_rgba(0,0,0,0.2)]"
            : "text-[var(--text-secondary)]",
        )}
      >
        <TrendingDown className="me-[6px] h-[13px] w-[13px]" />
        {isHe ? `הוצאות (${expenseCount})` : `Expenses (${expenseCount})`}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === "income"}
        onClick={() => onChange("income")}
        className={clsx(
          "inline-flex items-center rounded-[7px] px-[14px] py-[6px] text-[12px] font-medium transition-all duration-150 [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
          value === "income"
            ? "bg-[var(--bg-hover)] text-[var(--text-primary)] shadow-[0_1px_2px_rgba(0,0,0,0.2)]"
            : "text-[var(--text-secondary)]",
        )}
      >
        <TrendingUp className="me-[6px] h-[13px] w-[13px]" />
        {isHe ? `הכנסות (${incomeCount})` : `Income (${incomeCount})`}
      </button>
    </div>
  );
}

